import React from "react";
import { GetCorServicei } from './../_getjson';
import { Tab, Tabs } from "react-bootstrap"
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
require('./../_css/PopUpOther.css');
export default class PopUpCsHistory extends React.Component {
    constructor(props) {
        super(props);
        this.DiscountPersen = React.createRef();
        this.Discount = React.createRef();
        this.Code = React.createRef();
        this.BuyDate = React.createRef();
        this.Calendar1 = React.createRef();
        this.state = {
            col: [],
            rows: [],
            valueRetuen: "",
            Htext: "",
            SHtype: 3,
            casschkbox: "far fa-square",
            casschkboxs: false,
            ckbox_length: 0,
            docno: ""
        }
    }
    GetformatTimestamp = (date) => {
        if (date) {
            var myDate = new Date(date);
            var date1 = myDate.getDate(); if (myDate.getDate() < 10) { date = "0" + myDate.getDate(); }
            var month = (myDate.getMonth() + 1); if ((myDate.getMonth() + 1) < 10) { month = "0" + (myDate.getMonth() + 1); }
            var year = myDate.getFullYear() + 543;
            return date1 + "/" + month + "/" + year;
        } else {
            return "";
        }
    }
    Get_Data = (event, data) => {
        console.log(event, data);
        var dataArray = [];
        var code = ""
        if (event === "true") {
            code = "&docno=" + this.state.docno
        } else {
            code = "&docno=" + this.Code.current.value
        }

        var Url = "CSV_SALEREFDOCNO3/getsubdocno?arcode=" + this.props.ARCODE + code;
        GetCorServicei(Url, "").then(res => {
            var j = 0;
            if (res.data.length > 0) {
                for (let i = 0; i < res.data.length; i++) {
                    dataArray[j] = {
                        number: i + 1,
                        Col1: res.data[i].DOCNO,
                        Col2: res.data[i].PRODUCTCODE,
                        Col3: res.data[i].PRODUCTNAME,
                        Col4: res.data[i].UNITNAME,
                        Col5: res.data[i].ISSQTY,
                        Col6: res.data[i].ISSREM,
                        Col7: res.data[i].SHIPQTY,
                        Col8: res.data[i].UNITPRICE,
                        Col9: res.data[i].DISCWORD,
                        Col10: res.data[i].SALENAME,
                        Col11: res.data[i].SALEREMARK,
                        Col12: res.data[i].SHIPREMARK,
                        Col13: res.data[i].WAREHOUSE === null ? "" : typeof res.data[i].WAREHOUSE !== undefined ? res.data[i].WAREHOUSE : "",
                        Col14: res.data[i].LOCATION,
                        _unitCode: res.data[i].UNITCODE,
                        _refLineID: res.data[i].REFLINEID,
                        SB: "0",
                    }
                    j++;
                }

                this.setState({ col: dataArray });
                this.GetSearchTimeout();
            } else {
                dataArray = [];
                this.setState({ col: dataArray });
                this.GetSearchTimeout();
            }
        });
        this.setState({ col: dataArray, Htext: "เลือกรายการย่อย" });
        this.setState({ rows: this.state.rows });
    }
    GetSearchTimeout = () => {
        this.setState({ rows: this.state.col });
    }
    componentDidMount() {


    }
    /* setRow = (count) => {
        var data = [];
        for (var i = 0; i <= count - 1; i++) {
            data[i] = { C0: i + 1 };
        }
        this.setState({ rows: data });
    }; */
    cellcheckbok = (cell, row, enumObject, rowIndex) => {
        var btn = this.state.rows[rowIndex].SB;
        var btnShow;
        switch (btn) {
            case "0": btnShow = <span>
                <i className="far fa-square " onClick={this.Update_Status.bind(null, rowIndex, "1")}> </i>
            </span>;
                break;
            case "1": btnShow = <span>
                <i className="far fa-check-square" onClick={this.Update_Status.bind(null, rowIndex, "0")}>  </i>
            </span>;
                break;
            default: btnShow = <span><i className="">  </i></span>;
        }
        return (<div>{btnShow}</div>)
    }
    Update_Status = (Row, Status) => {
        var dataArray = this.state.rows;
        if (Status === "ALL") {
            if (this.state.casschkboxs === false) {
                this.setState({ casschkbox: "far fa-check-square" });
                this.setState({ casschkboxs: !this.state.casschkboxs });
                for (let i = 0; i < this.state.rows.length && this.state.rows[i].Col1; i++) {
                    dataArray[i].SB = "1";
                }
                this.setState({ row: dataArray });
            } else {
                this.setState({ casschkbox: "far fa-square" });
                this.setState({ casschkboxs: !this.state.casschkboxs });
                for (let i = 0; i < this.state.rows.length && this.state.rows[i].Col1; i++) {
                    dataArray[i].SB = "0";
                }
                this.setState({ row: dataArray });
            }
        } else {
            if (Status === "0") {
                this.setState({ casschkbox: "far fa-square" });
                this.setState({ casschkboxs: false });
            }
            dataArray[Row].SB = Status;
            this.setState({ rows: dataArray });
            var sb_length = 0;
            for (let i = 0; i < this.state.rows.length && this.state.rows[i].DOCNO; i++) {
                if (this.state.rows[i].SB === 1) { sb_length = sb_length + 1; }
            }
            if (sb_length === this.state.rows.length) {
                this.setState({ casschkbox: "far fa-check-square" });
                this.setState({ casschkboxs: true });
            }
        }
    }

    onSelectRow = (data, col, id, row) => {
        this.setState({ valueRetuen: data.code });

        if (col > 1 && data.Col1 !== undefined) {
            //เท่ากับเลือกรายการเมื่อคลิกแถว
            var dataArray = this.state.rows;
            dataArray[id].SB = "1";
            this.setState({ rows: dataArray });
            this.setState({ Col1: data.Col1 });
            console.log(data.Col1);
            //------------------------
            var reData = [];
            let j = 0;
            for (var i = 0; i < this.state.rows.length && this.state.rows[i].Col1; i++) {
                console.log(this.state.rows[i].SB);
                if (this.state.rows[i].SB === "1") {
                    reData[j] = {
                        Col1: this.state.rows[i].Col1,
                        Col2: this.state.rows[i].Col2,
                        Col3: this.state.rows[i].Col3,
                        Col4: this.state.rows[i].Col4,
                        Col5: this.state.rows[i].Col5,
                        Col6: this.state.rows[i].Col6,
                        Col7: this.state.rows[i].Col7,
                        Col8: this.state.rows[i].Col8,
                        Col9: this.state.rows[i].Col9,
                        Col10: this.state.rows[i].Col10,
                        Col11: this.state.rows[i].Col11,
                        Col12: this.state.rows[i].Col12,
                        Col13: this.state.rows[i].Col13,
                        Col14: this.state.rows[i].Col14,
                        _unitCode: this.state.rows[i]._unitCode,
                        _refLineID: this.state.rows[i]._refLineID,
                    }
                    j++
                }
            }
            /* console.log(reData.length); */
            if (reData.length !== 0) {
                this.props.Get_PopUpSelSaleRef3Sub(reData);
            }
        }
    }
    onSubmit = (e) => {
        var sb_length = 0;
        var reData = [];
        for (var i = 0; i < this.state.rows.length && this.state.rows[i].Col1; i++) {
            console.log(this.state.rows[i].SB);
            if (this.state.rows[i].SB === 1) {
                sb_length = sb_length + 1;
                reData[i] = {
                    Col1: this.state.rows[i].Col1,
                    Col2: this.state.rows[i].Col2,
                    Col3: this.state.rows[i].Col3,
                    Col4: this.state.rows[i].Col4,
                    Col5: this.state.rows[i].Col5,
                    Col6: this.state.rows[i].Col6,
                    Col7: this.state.rows[i].Col7,
                    Col8: this.state.rows[i].Col8,
                    Col9: this.state.rows[i].Col9,
                    Col10: this.state.rows[i].Col10,
                    Col11: this.state.rows[i].Col11,
                    Col12: this.state.rows[i].Col12,
                    Col13: this.state.rows[i].Col13,
                    Col14: this.state.rows[i].Col14,
                    _unitCode: this.state.rows[i]._unitCode,
                    _refLineID: this.state.rows[i]._refLineID,
                }
            }
        }
        if (reData.length === sb_length && reData.length !== 0) {
            this.props.Get_PopUpSelSaleRef3Sub(reData);
        }
    };
    onRowClick = (row, col, id) => {
        this.setState({ cellValue: row.StCode })
        this.setState({ id: id })
        var Pr = this.state.products1;
        var j = "";
        // ไม่ให้คีย์ข้ามแถว
        this.setState({ col1: false });
        this.setState({ col: false });

        for (let i = this.state.products1.length - 1; i >= 0; i--) {
            //หา แถวที่ว่างบนสุดใน products1 Table
            if (!Pr[i].StCode) { j = i; }
        }
        for (let i = 0; i < Pr.length; i++) {
            Pr[i].BTN_StCode = 0;
            Pr[i].BTN_SpCode = 0;
        }
        if ((col === 1 && j === id) || (col === 1 && Pr[id].StCode !== undefined && Pr[id].StCode !== "")) {
            this.setState({ col1: true });
            Pr[id].BTN_StCode = 1;
        } else if (col === 3 && typeof row.StCode !== "undefined" && row.StCode !== "") {
            Pr[id].BTN_SpCode = 1;
        }
        if (col === 1 && Pr[id].StCode !== "") {
            this.setState({ StCode: Pr[id].StCode });
            Pr[id].StCode = Pr[id].StName;
        }
        if (col === 3 && Pr[id].SpCode !== "") {
            this.setState({ SpCode: Pr[id].SpCode });
            Pr[id].SpCode = Pr[id].SpName;
        }
        // ให้เพิ่มข้อมูลในแถวที่มีรหัสสินค้าได้
        if (typeof row.StCode !== "undefined" && row.StCode !== "") {
            this.setState({ col: true });
        }
        this.setState({ products1: Pr });
    }
    render() {
        return (

            <div className='popup' style={{ 'z-index': '100' }} >
                <div className='popup_inner'>
                    {this.props.Data}
                    <div className="PopUpOtherDivH" align="left">
                        <div className="PopUpOtherDivH1">
                            <i className="fas fa-user"> ข้อมูลลูกค้า</i>
                        </div>
                        <div className="PopUpOtherDivH2" onClick={this.props.closePopup}>
                            <i className="fas fa-times"></i>
                        </div>
                    </div>
                    <style jsx>{`
                        .form-group.col-xs-6.col-sm-6.col-lg-6.col-md-6 {
                            margin-top: 5px;
                        }
                        .form-group.col-xs-3.col-sm-3.col-lg-3.col-md-3 {
                            margin-top: 5px;
                        }
                    `}</style>
                    <div className="panel-body divTable" align="right">
                        <div className="row">
                            <div className="form-group col-xs-10 col-sm-10 col-lg-10 col-md-10">
                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon">ชื่อลูกค้า : </span>
                                    <input type="text" className="form-control" ref={this.BuyDate} />
                                    <span className="input-group-addon icon"></span>
                                </div>
                            </div>
                            <div className="form-group col-xs-6 col-sm-6 col-lg-6 col-md-6">
                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon">ใบเสนอราคา : </span>
                                    <input type="number" className="form-control Price" ref={this.DiscountPersen} />
                                    <span className="input-group-addon icon">
                                        <i className="fas fa-calculator"></i>
                                    </span>
                                    <input type="text" className="form-control Price" ref={this.Discount} disabled />
                                </div>
                            </div>
                            <div className="form-group col-xs-4 col-sm-4 col-lg-4 col-md-4">
                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon">วงเงินทั้งหมด : </span>
                                    <input type="text" className="form-control" ref={this.Calendar1} />
                                    <span className="input-group-addon icon"><i className="fas fa-calculator"></i></span>
                                </div>
                            </div>
                            <div className="form-group col-xs-6 col-sm-6 col-lg-6 col-md-6">
                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon">ใบสั่งจอง : </span>
                                    <input type="number" className="form-control Price" ref={this.DiscountPersen} />
                                    <span className="input-group-addon icon">
                                        <i className="fas fa-calculator"></i>
                                    </span>
                                    <input type="text" className="form-control Price" ref={this.Discount} disabled />
                                </div>
                            </div>
                            <div className="form-group col-xs-6 col-sm-6 col-lg-6 col-md-6">
                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon">ยอดหนี้คงเหลือ : </span>
                                    <input type="number" className="form-control Price" ref={this.DiscountPersen} />
                                    <span className="input-group-addon icon">
                                        <i className="fas fa-calculator"></i>
                                    </span>
                                    <input type="text" className="form-control Price" ref={this.Discount} disabled />
                                </div>
                            </div>
                            <div className="form-group col-xs-6 col-sm-6 col-lg-6 col-md-6">
                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon">ใบสั่งขาย : </span>
                                    <input type="number" className="form-control Price" ref={this.DiscountPersen} />
                                    <span className="input-group-addon icon">
                                        <i className="fas fa-calculator"></i>
                                    </span>
                                    <input type="text" className="form-control Price" ref={this.Discount} disabled />
                                </div>
                            </div>
                            <div className="form-group col-xs-6 col-sm-6 col-lg-6 col-md-6">
                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon">เช็คในมือ : </span>
                                    <input type="number" className="form-control Price" ref={this.DiscountPersen} />
                                    <span className="input-group-addon icon">
                                        <i className="fas fa-calculator"></i>
                                    </span>
                                    <input type="text" className="form-control Price" ref={this.Discount} disabled />
                                </div>
                            </div>
                            <div className="form-group col-xs-6 col-sm-6 col-lg-6 col-md-6">
                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon">รับเงินล่วงหน้า : </span>
                                    <input type="number" className="form-control Price" ref={this.DiscountPersen} />
                                    <span className="input-group-addon icon">
                                        <i className="fas fa-calculator"></i>
                                    </span>
                                    <input type="text" className="form-control Price" ref={this.Discount} disabled />
                                </div>
                            </div>
                            <div className="form-group col-xs-6 col-sm-6 col-lg-6 col-md-6">
                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon">เช็คคืน : </span>
                                    <input type="number" className="form-control Price" ref={this.DiscountPersen} />
                                    <span className="input-group-addon icon">
                                        <i className="fas fa-calculator"></i>
                                    </span>
                                    <input type="text" className="form-control Price" ref={this.Discount} disabled />
                                </div>
                            </div>
                        </div>
                        <div className="row" style={{ marginTop: "10px" }}>
                            <div className="form-group col-xs-6 col-sm-6 col-lg-6 col-md-6">
                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon">Inv ไม่ถึงกำหนด : </span>
                                    <input type="number" className="form-control Price" ref={this.DiscountPersen} />
                                    <span className="input-group-addon icon">
                                        <i className="fas fa-calculator"></i>
                                    </span>
                                    <input type="text" className="form-control Price" ref={this.Discount} disabled />
                                </div>
                            </div>
                            <div className="form-group col-xs-4 col-sm-4 col-lg-4 col-md-4">
                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon">วงเงินคงเหลือ : </span>
                                    <input type="number" className="form-control Price" ref={this.DiscountPersen} />
                                    <span className="input-group-addon icon"><i className="fas fa-calculator"></i></span>
                                </div>
                            </div>
                            <div className="form-group col-xs-6 col-sm-6 col-lg-6 col-md-6">
                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon">Ivn เกินกำหนด : </span>
                                    <input type="number" className="form-control Price" ref={this.DiscountPersen} />
                                    <span className="input-group-addon icon">
                                        <i className="fas fa-calculator"></i>
                                    </span>
                                    <input type="text" className="form-control Price" ref={this.Discount} disabled />
                                </div>
                            </div>
                            <div className="form-group col-xs-3 col-sm-3 col-lg-3 col-md-3">
                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon">รับชำระล่าสุด : </span>
                                    <input type="number" className="form-control Price" ref={this.DiscountPersen} />
                                    <span className="input-group-addon icon">
                                        <i className="fas fa-calendar-alt selectFix"></i>
                                    </span>
                                </div>
                            </div>
                            <div className="form-group col-xs-3 col-sm-3 col-lg-3 col-md-3">
                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon">ขายล่าสุด : </span>
                                    <input type="number" className="form-control Price" ref={this.DiscountPersen} />
                                    <span className="input-group-addon icon">
                                        <i className="fas fa-calendar-alt selectFix"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <br />
                        <Tabs defaultActiveKey="SelectTab1" id="uncontrolled-tab-example" onSelect={(eventKey) => this.setState({ key: eventKey })}>
                            <Tab eventKey="SelectTab1" title="ลูกหนี้คงค้าง" >
                                <br />
                                <BootstrapTable height="300" data={this.state.products1} style={{ marginTop: "50px" }}>
                                    <TableHeaderColumn dataField='id1' width="50" dataAlign="center" isKey></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode1' width="90"><div style={{ textAlign: "center" }}>เอกสารตั้งหนี้</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode2' width="90" ><div style={{ textAlign: "center" }}>ใบกำกับภาษี</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode3' width="90" ><div style={{ textAlign: "center" }}>วันที่ตั้งหนี้</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode4' width="90" ><div style={{ textAlign: "center" }}>เครดิต</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode5' width="90" ><div style={{ textAlign: "center" }}>ครบกำหนด</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode6' width="90" ><div style={{ textAlign: "center" }}>รายวัน</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode7' width="90" ><div style={{ textAlign: "center" }}>แผนก</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode8' width="90" ><div style={{ textAlign: "center" }}>ยอดตั้งหนี้</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode9' width="90" ><div style={{ textAlign: "center" }}>ยอดคงค้าง</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode10' width="90" ><div style={{ textAlign: "center" }}>ยอดวางบิล</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode11' width="90" ><div style={{ textAlign: "center" }}>ยอดเตรียม</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode12' width="90" ><div style={{ textAlign: "center" }}>คงค้างสุทธิ</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='Description1'><div style={{ textAlign: "center" }}>หมายเหตุ</div></TableHeaderColumn>
                                </BootstrapTable>
                            </Tab>
                            <Tab eventKey="SelectTab2" title="สถานะเช็ค" >
                                <br />
                                <BootstrapTable height="300" data={this.state.products2} style={{ marginTop: "50px" }}>
                                    <TableHeaderColumn dataField='id2' width="50" dataAlign="center" isKey></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90"><div style={{ textAlign: "center" }}>เลขที่เช็ค</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90" ><div style={{ textAlign: "center" }}>ธนาคาร</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90" ><div style={{ textAlign: "center" }}>สาขา</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90" ><div style={{ textAlign: "center" }}>ครบกำหนด</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90" ><div style={{ textAlign: "center" }}>วันที่รับ</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90" ><div style={{ textAlign: "center" }}>เลขที่เอกสาร</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90" ><div style={{ textAlign: "center" }}>มูลค่า</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90" ><div style={{ textAlign: "center" }}>สถานะ</div></TableHeaderColumn>
                                </BootstrapTable>
                            </Tab>
                            <Tab eventKey="SelectTab3" title="ประวัติเช็คคืน" >
                                <br />
                                <BootstrapTable height="300" data={this.state.product3s} style={{ marginTop: "50px" }}>
                                    <TableHeaderColumn dataField='id2' width="50" dataAlign="center" isKey></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90"><div style={{ textAlign: "center" }}>เลขที่เช็ค</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90" ><div style={{ textAlign: "center" }}>ธนาคาร</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90" ><div style={{ textAlign: "center" }}>สาขา</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90" ><div style={{ textAlign: "center" }}>ครบกำหนด</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90" ><div style={{ textAlign: "center" }}>วันที่รับ</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90" ><div style={{ textAlign: "center" }}>เลขที่เอกสาร</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90" ><div style={{ textAlign: "center" }}>มูลค่า</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90" ><div style={{ textAlign: "center" }}>หมายเหตุ</div></TableHeaderColumn>
                                </BootstrapTable>
                            </Tab>
                            <Tab eventKey="SelectTab4" title="ประวัติการขาย" >
                                <br />
                                <BootstrapTable height="300" data={this.state.products4} style={{ marginTop: "50px" }}>
                                    <TableHeaderColumn dataField='id2' width="50" dataAlign="center" isKey></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90"><div style={{ textAlign: "center" }}>วันที่</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90" ><div style={{ textAlign: "center" }}>เลขที่</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90" ><div style={{ textAlign: "center" }}>รหัสสินค้า</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90" ><div style={{ textAlign: "center" }}>ปริมาณ</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90" ><div style={{ textAlign: "center" }}>หน่วย</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90" ><div style={{ textAlign: "center" }}>ราคาขาย</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90" ><div style={{ textAlign: "center" }}>ลด</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90" ><div style={{ textAlign: "center" }}>เครดิต</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90" ><div style={{ textAlign: "center" }}>ประเภท</div></TableHeaderColumn>
                                </BootstrapTable>
                            </Tab>
                            <Tab eventKey="SelectTab5" title="สินค้าค้างส่ง" >
                                <br />
                                <BootstrapTable height="300" data={this.state.products5} style={{ marginTop: "50px" }}>
                                    <TableHeaderColumn dataField='id2' width="50" dataAlign="center" isKey></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90"><div style={{ textAlign: "center" }}>วันที่</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90" ><div style={{ textAlign: "center" }}>นัดส่งมอบ</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90" ><div style={{ textAlign: "center" }}>เลขที่</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90" ><div style={{ textAlign: "center" }}>รหัสสินค้า</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90" ><div style={{ textAlign: "center" }}>ชื่อสินค้า</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90" ><div style={{ textAlign: "center" }}>ปริมาณ</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90" ><div style={{ textAlign: "center" }}>ค้างส่ง</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90" ><div style={{ textAlign: "center" }}>หน่วย</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90" ><div style={{ textAlign: "center" }}>ราคาขาย</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90" ><div style={{ textAlign: "center" }}>ลด</div></TableHeaderColumn>
                                </BootstrapTable>
                            </Tab>
                            <Tab eventKey="SelectTab6" title="วงเงินร่วม" >
                                <br />
                                <BootstrapTable height="300" data={this.state.products6} style={{ marginTop: "50px" }}>
                                    <TableHeaderColumn dataField='id2' width="50" dataAlign="center" isKey></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90"><div style={{ textAlign: "center" }}>รหัสลูกค้า</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90"><div style={{ textAlign: "center" }}>ชื่อลูกค้า</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90"><div style={{ textAlign: "center" }}>ยอดหนี้คงค้าง</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90"><div style={{ textAlign: "center" }}>เช็คในมือ</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90"><div style={{ textAlign: "center" }}>เช็คคืน</div></TableHeaderColumn>
                                </BootstrapTable>
                            </Tab>
                            <Tab eventKey="SelectTab7" title="เป้าการขาย/Rebate" >
                                <br />
                                <BootstrapTable height="300" data={this.state.products7}
                                    // options={{ noDataText: "...", onRowClick: this.onRowClick }}
                                    cellEdit={{
                                        mode: 'click', blurToSave: true,
                                        /*  afterSaveCell: this.onAfterSaveCell */
                                    }}>
                                    <TableHeaderColumn dataField='id2' width="50" dataAlign="center" isKey></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90"><div style={{ textAlign: "center" }}>รหัส</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90"><div style={{ textAlign: "center" }}>ชื่อกลุ่ม rebate</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90"><div style={{ textAlign: "center" }}>ประเภท</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90"><div style={{ textAlign: "center" }}>มูลค่า</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90"><div style={{ textAlign: "center" }}>เงื่อนไขพิเศษ#1</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90"><div style={{ textAlign: "center" }}>เงื่อนไขพิเศษ#2</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90"><div style={{ textAlign: "center" }}>จากวันที่</div></TableHeaderColumn>
                                    <TableHeaderColumn dataField='ArCode' width="90"><div style={{ textAlign: "center" }}>ถึงวันที่</div></TableHeaderColumn>
                                </BootstrapTable>
                            </Tab>
                        </Tabs>
                        {this.state.TableHidden ? ("") : (
                            <button className="PUSDbtn" onClick={this.props.closePopup} >
                                <i className="fas fa-reply-all"> กลับ </i>
                            </button>
                        )}
                        <button className="PUSDbtn" onClick={this.onSubmit}>
                            <i className="fas fa-check"> ตกลง </i>
                        </button>
                    </div>
                </div>
            </div >
        );
    }
}